//External Components
import React from "react";
import { BsDoorOpenFill, BsList } from "react-icons/bs"
import '../../assets/scss/navbar.scss'
//Context
import DataContext from "../../dataContext";

export default function Header(props) {

    const context = React.useContext(DataContext)

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light row justify-content-between sticky-md-top px-4 py-4">
            <div className={"col-4 align-items-lg-start"}>
                <button type="button" id="sidebarCollapse" className="btn btn-info btn-menu p-0" onClick={() => {
                    props.active.setActive(!props.active.active)
                }}>
                    <BsList size={30} />
                </button>
            </div>

            <div className={"col-4 align-items-center"}>
                <p className={"text-capitalize text-middle my-auto text-end"} style={{ cursor: "pointer" }} onClick={() => {
                    context.logout()
                }}><BsDoorOpenFill /> {context.user.name} {context.user.lastName}</p>
            </div>
        </nav>
    )
}